import { s, typographyTokens } from '@/theme/tokens';

export const tableV2MetadataCellGap = `calc((${s('sm')} + ${s('md')}) / 2)`;

export const tableV2ProjectCellFrameSx = {
  alignItems: 'center',
  display: 'flex',
  gap: tableV2MetadataCellGap,
  minWidth: 0,
} as const;

export const tableV2ProjectCellTooltipTitleFrameSx = {
  alignItems: 'center',
  display: 'inline-flex',
  gap: tableV2MetadataCellGap,
} as const;

export const tableV2ProjectCellTooltipTextSx = {
  fontSize: '13px !important',
} as const;

export const tableV2ProjectCellTooltipWrapperSx = {
  minWidth: 0,
} as const;

export const tableV2ProjectCellTextSx = {
  display: 'block',
  fontSize: '13px !important',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export const tableV2DurationCellTextSx = {
  fontSize: typographyTokens.body.fontSize,
  fontVariantNumeric: 'tabular-nums',
  fontWeight: typographyTokens.bodyMedium.fontWeight,
} as const;
